import dayjs from "dayjs"
import relativeTime from "dayjs/plugin/relativeTime"

dayjs.extend(relativeTime)

export default function determineDaysDue(date: string | Date) {
    return `Due ${dayjs().to(date)}`
}
